const roundReportStorageItemAdminStatuses = {
    notStarted: {},
    processing: {},
    completed: {}
};

Object.keys(roundReportStorageItemAdminStatuses).forEach(key => {
    roundReportStorageItemAdminStatuses[key].key = key;
});

export default roundReportStorageItemAdminStatuses;
